module.exports = __webpack_public_path__ + "img/navBar.6f0f4dd3.png";